import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-404"
};
import { useRouter } from 'vue-router';
import { toRefs } from 'vue';
export default {
  __name: '404',
  props: {
    to: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const router = useRouter();
    const props = __props;
    const {
      to,
      from
    } = toRefs(props);
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("h1", null, "404", -1)), _createElementVNode("h2", null, "抱歉，你访问的页面[" + _toDisplayString(_unref(to)) + "]不存在！", 1), _createVNode(_component_vxe_button_group, null, {
        default: _withCtx(() => [_createVNode(_component_vxe_button, {
          status: "primary",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/'))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("首页", -1)]))]),
          _: 1
        }), _createVNode(_component_vxe_button, {
          mode: "text",
          onClick: _cache[1] || (_cache[1] = $event => _unref(router).push(_unref(from)))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("返回", -1)]))]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};